import { OffersTypes } from '../types';

export const getOffersDataToSubmit = (offers: OffersTypes | null) => {
  if (!offers?.offerDetails) return undefined;
  const { creditBonus, customerDownPayment, monthlyPayment, term, type, cpoTerm, aprRate } =
    offers.offerDetails;

  const termForCPO = Number((cpoTerm && cpoTerm.match(/\d+$/)?.[0]) || 0);
  const normilizedTerm = type === 'NEW-CAR' || type === 'new' ? term : termForCPO;
  const normalizedFinanceMethod = offers.offerType === 'credit' ? 'finance' : offers.offerType;

  return {
    financeMethod: normalizedFinanceMethod,
    financeTerm: normilizedTerm ?? 0,
    apr: aprRate,
    amounts: [
      {
        type: 'downpayment',
        value: parseNumber(customerDownPayment),
        description: 'Loan principle amount',
      },
      { type: 'monthly', value: parseNumber(monthlyPayment), description: 'Loan monthly amount' },
      { type: 'other', value: parseNumber(creditBonus), description: 'Eligible Credit Bonus' },
    ],
  };
};

export const getOffersVehicleDataToSubmit = (offers: OffersTypes | null) => {
  if (!offers) return undefined;

  const { type } = offers.offerDetails;
  const status = type === 'NEW-CAR' || type === 'new' ? 'new' : 'CPO';
  return {
    model: offers?.modelName,
    year: offers?.modelYear,
    trim: offers?.trimName,
    status,
    make: 'Audi',
  };
};

const parseNumber = (value: string | number | undefined | null): number => {
  if (typeof value === 'number') return Number.isNaN(value) ? 0 : value;
  if (typeof value !== 'string') return 0;

  // Strips everything except digits, decimal points, and negative signs (e.g., "$15,000.50" -> "15000.50")
  const cleanString = value.replace(/[^0-9.-]+/g, '');
  const parsed = parseFloat(cleanString);

  return Number.isNaN(parsed) ? 0 : parsed;
};
